import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

// Default language of the app. Used on first visit, on every login and after logout.
export const DEFAULT_LANGUAGE = 'en-US';

// true  -> every login starts in English (the user can still switch in Settings).
// false -> on login, use the language saved in the user's profile (old behaviour).
export const FORCE_DEFAULT_LANGUAGE_ON_LOGIN = true;

// eslint-disable-next-line import/no-named-as-default-member
i18n
	// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
	// learn more: https://github.com/i18next/i18next-http-backend
	// want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: DEFAULT_LANGUAGE,
		debug: false,

		// Only remember the language the user picked in this browser (localStorage).
		// The browser / OS language is NOT used anymore, so a French browser no
		// longer opens the app in French. If nothing is saved -> English.
		detection: {
			order: ['localStorage'],
			lookupLocalStorage: 'i18nextLng',
			caches: ['localStorage'],
		},

		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		react: {
			useSuspense: false,
		},
	});

export default i18n;